import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import { closeConfirmDialog } from "../../../redux/actions/uiConfirmDialog";

function ConfirmDialog() {

  const dispatch = useDispatch();

  const { confirmDialogOpen, title, message, onOk, noMessage, YesNessage } = useSelector( state => state.uiConfirmDialog );

  const handleClose = () => {
    dispatch(closeConfirmDialog());
  };

  const handleConfirm = () => {
    onOk();        
    handleClose();    
  };

  return (
    <Dialog
      open={confirmDialogOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{title || ""}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {noMessage ? noMessage : "No"}
        </Button>
        <Button onClick={handleConfirm} color="primary" autoFocus>          
          {YesNessage ? YesNessage : "Yes, remove!"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog;
